import { createContext, useContext, useState, ReactNode } from 'react';

interface ListSearchFilterContextType {
  searchFilter: string;
  setSearchFilter: (filter: string) => void;
}

const ListSearchFilterContext = createContext<ListSearchFilterContextType | undefined>(undefined);

interface ListSearchFilterProviderProps {
  children: ReactNode;
}

export function ListSearchFilterProvider({ children }: ListSearchFilterProviderProps) {
  const [searchFilter, setSearchFilter] = useState('');

  return (
    <ListSearchFilterContext.Provider value={{ searchFilter, setSearchFilter }}>
      {children}
    </ListSearchFilterContext.Provider>
  );
}

export function useListSearchFilter() {
  const context = useContext(ListSearchFilterContext);
  if (context === undefined) {
    throw new Error('useListSearchFilter must be used within a ListSearchFilterProvider');
  }
  return context;
}
